import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpRightAndDownLeftFromCenter} from "@fortawesome/free-solid-svg-icons";

const PrimaryVehicleEnlarge = ({enlargeView, t}) => {
    return (
        <React.Fragment>
            <button className={'btn-default enlarge-btn'}
                    id={"photos-enlarge-button"}
                    onClick={() => enlargeView()}>
                    <span>
                        <span className="photos-enlarge-button">
                        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
                    </span>
                    <span>
                        {t('photo.enlarge.buttonText')}
                    </span>
                    </span>
            </button>
        </React.Fragment>
    );
}

export default PrimaryVehicleEnlarge;